

import WebServiceRequest from '../../Api/WebServiceRequest'

class ChangeTicketStatus extends WebServiceRequest {
    constructor (context) {
        super(context)
    }
    setId(data){
        super.setTag(`Ticket/ChangeTicketStatus?parentId=${data.parentId}`)
    }
}
export default ChangeTicketStatus;
